import Swiper, { Navigation, Pagination } from 'swiper';

class Carousel {
    init() {
        this.initCarousel();
    }

    initCarousel() {
        let carousels = document.querySelectorAll('.carousel');

        if (carousels !== null) {
            carousels.forEach((carousel, index) => {
                let carouselId = carousel.getAttribute('data-carousel-id');

                const swiper = new Swiper(`.carousel-${carouselId}`, {
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 20
                        },
                        576: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 20
                        }
                    },
                    navigation: {
                        nextEl: `.next-${carouselId}`,
                        prevEl: `.prev-${carouselId}`,
                    },
                    modules: [Navigation, Pagination],
                    pagination: {
                        clickable: true,
                        el: `.pagination-${carouselId}`,
                    },
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                });
            });
        }
    }
}

export default Carousel;

(() => {
    const carousel = new Carousel();
    carousel.init();
})();
